<template>
  <div class="home" :dir="isHebrew ? 'rtl' : 'ltr'">
    <WhatsappChet/>
    <SingleRideHeader  
      :presentedText="t('recommendedHotels')"
    >
    </SingleRideHeader>
      <div class="trip-card-section after_page_header">
        <div class="container serch_attraction_categories">
          <div class="trip-card-top">
            <div class="search-label">{{ t('searchByLocation') }}</div>
            <div class="search-container">
              <span class="search-icon">🔍</span>
              <!-- TODO we should update this mathod in ordetr to serch the accomodation eriaya  -------------------------------- -->
              <GlobalMapSerchAutoComplet
                class="gmap-autocomplete1"
                @handleserchPointChange="handleUpdateSerchAccommodationPoint"
              />
            </div>
            <div class="search-helper-text">{{ t('searchExampleLocations') }}</div>
            <a v-if="allRide.ride" class="trip-btn-bg" @click="ReturnToSingleRide()">{{ t('backToTrip') }}</a>
          </div>
        </div>
      </div>
      <div class="trip-activity-section">
				<div class="container">
          <div class="row">
            <div class="col-xl-7 col-lg-8">
              <div class="trip-sidebar">
                <SearchAccommodations />
              </div>
            </div>
            <div class="col-xl-5 col-lg-4">
              <div class="trip-map-four serch_attraction_map_header">
                <div class="trip-location">
                  <ul>
                    <!-- <li>פעילויות שכבר קיימות בטיול<img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FfullColers%2FpointWithFullColler_07A0C3.png?alt=media&token=c3e342d6-f425-495f-842d-c0e6edd2730e" alt=""></li> -->
                    <li>{{ t('topAccommodationInList') }}<img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fmap_letter%2Fblack_numbers%2Fblack_map_Icon_empty.png?alt=media&token=ae5de8aa-cee4-47a7-966b-e02eb1b93480'" alt=""></li>
                  </ul>
                </div>
                <div >
                  <div >
                    <GlobalMap
                    passed_class="single_ride_map">
                    </GlobalMap>
                  </div>
                  <img src="images/map-two.png" alt="">
                </div>
              </div>
            </div>
          </div>
				</div>
      </div>
    <PageFooter />
  </div>
</template>

<script>

import config from '@/common/config';
import PageFooter from '@/components/PageFooter.vue'
import SearchAccommodations from '@/components/SearchAccommodations';
import GlobalMap from '@/components/GlobalMap';
import SingleRideHeader from '@/components/SingleRideHeader';
import GlobalMapSerchAutoComplet from '@/components/GlobalMapSerchAutoComplet';
import WhatsappChet from "@/components/WhatsappChet";
import { mapActions, mapGetters } from 'vuex';
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: 'SearchAccommodationWithMap',
  components: {
    GlobalMapSerchAutoComplet,
    SearchAccommodations,
    GlobalMap,
    PageFooter,
    SingleRideHeader,
    WhatsappChet,
  },
  mixins: [translationMixin],
  computed: mapGetters([  'allRide',
                          'searchAccommodationDayIndex',
                          'isUserManager',
                       ]),
  methods: {
    ...mapActions([ 'updateMarkerByScrollerLocationAtAccommodationSearch',
                    'ReturnToSingleRide',
                    'goToSerchAccommodations',
                    'goToSerchAccommodationsByName',
                     ]),
    handleUpdateSerchAccommodationPoint( place ){
      const lat = place.geometry.location.lat()
      const lng = place.geometry.location.lng()
      // Preserve the existing dayIndex when updating the search point
      // Use isUserManager to determine if this is a ride manager search
      this.goToSerchAccommodations({
        location: {"latitude":lat, "longtitude":lng},
        isRideManager: this.isUserManager,
        dayIndex: this.searchAccommodationDayIndex
      });
   },
  },
  created(){
    const location_name = this.$route.params.location_name;
    const urlName = this.$route.name;
    if( config.config.ROUTES_URL_NAMES.searchAccommodationsNyName == urlName && location_name){
      this.goToSerchAccommodationsByName(location_name);
    }
    window.addEventListener('scroll', this.updateMarkerByScrollerLocationAtAccommodationSearch);
  },
  mounted(){
    this.$store.commit('setAccommodationPresentedDay', null);
    const sectionHeroElMap = document.querySelector(".serch_attraction_categories");
    const obsMap = new IntersectionObserver(
      function (entries) {
        const ent = entries[0];
        if ( (ent.isIntersecting === false) && ( ent.boundingClientRect.y < 0) ) {
          document.body.classList.add("serch_attraction_map_sticky");
        }
        if (ent.isIntersecting === true) {
          document.body.classList.remove("serch_attraction_map_sticky");
        }
      },
      {
        // In the viewport
        root: null,
        threshold: 0,
        rootMargin: "-40px",
      }
    );
    obsMap.observe(sectionHeroElMap);
  },
  destroyed(){
    window.removeEventListener('scroll', this.updateMarkerByScrollerLocationAtAccommodationSearch);
  },
  metaInfo() {
    const location = this.$route.params.location_name;
    const pageUrl = location
      ? `https://tripplanner.co.il/search_accommodations_by_name/${location}`
      : 'https://tripplanner.co.il/search_accommodations';
    const title = location
      ? this.t('searchAccommodationMetaTitleWithLocation', { location })
      : this.t('searchAccommodationMetaTitle');
    const description = location
      ? this.t('searchAccommodationMetaDescription', { location })
      : this.t('searchAccommodationsMetaDescription');
    return {
      title,
      meta: [
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: pageUrl },
        { name: 'description', content: description }
      ],
      link: [
        { rel: 'canonical', href: pageUrl }
      ]
    };
  }
  
};


</script>

<style scoped>

.after_page_header{
  margin-top: 20rem;
}
@media (max-width: 991px) {
  .after_page_header{
    margin-top: 15rem;
  }
}

.trip-card-top {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  padding: 0 16px; /* add horizontal padding for small screens */
}

.search-label {
  font-weight: bold;
  font-size: 16px;
  color: #333;
  width: 100%;
}

.home[dir="rtl"] .trip-card-top,
.home[dir="ltr"] .trip-card-top {
  text-align: center !important;
}

.home[dir="rtl"] .trip-card-top .search-label,
.home[dir="ltr"] .trip-card-top .search-label {
  text-align: center !important;
}

.search-container {
  position: relative;
  display: flex; /* was 'block' — now flex for better layout */
  align-items: center;
  justify-content: center; /* center the input and icon */
  background: #f0f0f0;
  border-radius: 8px;
  padding: 12px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto; /* center horizontally */
  box-sizing: border-box;
}

[dir="rtl"] .search-container {
  flex-direction: row-reverse;
}

[dir="ltr"] .search-container {
  flex-direction: row;
}

.search-icon {
  margin-inline-end: 8px;
  font-size: 18px;
  color: #555;
}

.search-helper-text {
  font-size: 12px;
  color: #666;
  width: 100%;
}

.home[dir="rtl"] .trip-card-top .search-helper-text,
.home[dir="ltr"] .trip-card-top .search-helper-text {
  text-align: center !important;
}

/* Back button style (if not already styled elsewhere) */
.trip-btn-bg {
  background-color: #07A0C3;
  color: white;
  padding: 10px;
  border-radius: 6px;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  max-width: fit-content;
}

/* ✅ Responsive adjustments for mobile screens */
@media (max-width: 600px) {
  .gmap-autocomplete1 {
    width: 100% !important;
    max-width: 100%;
  }

  .search-container {
    padding: 8px;
  }

  .search-icon {
    font-size: 16px;
    margin-inline-end: 4px;
  }

  .search-label,
  .search-helper-text {
    font-size: 14px;
  }

  .trip-btn-bg {
    width: 100%;
    text-align: center;
  }
}

.gmap-autocomplete1 {
  width: 100% !important;
  max-width: 500px;
  box-sizing: border-box; /* ensures padding doesn't overflow */
}

</style>
